﻿/***************MENUS START******************/

let dropDownMenus = [];
let dropDownMenuHide = (menu, toggle) => {
    menu.classList.remove("dropdown-menu-open");
    toggle.classList.remove("dropdown-toggle-open");
};
let dropDownMenuShow = (menu, toggle) => {
    dropDownMenus.forEach((target) => {
        dropDownMenuHide(target.menu, target.toggle);
    });
    toggle.classList.add("dropdown-toggle-open");
    menu.classList.add("dropdown-menu-open");
};
let dropDownMenuToggle = (menu, toggle) => {
    if (menu.classList.contains("dropdown-menu-open") === true) {
        dropDownMenuHide(menu, toggle);
    } else {
        dropDownMenuShow(menu, toggle);
    }
};

let mq = window.matchMedia("(max-width: 767px)");

if (mq.addEventListener) {
    mq.addEventListener("change", mqMatchesDropDownMenuHide);
} else {
    mq.addListener(mqMatchesDropDownMenuHide);
}

function mqMatchesDropDownMenuHide() {
    if (!mq.matches) {
        dropDownMenus.forEach(function (target) {
            dropDownMenuHide(target.menu, target.toggle);
        });
    }
}

let dropDownItems = document.querySelectorAll(".dropdown-item");

if (!mq.matches) {
    dropDownItems.forEach(item => {
        let dropDownMenu = item.querySelector('.dropdown-menu');
        if (dropDownMenu) {
            dropDownMenu.classList.remove('dropdown-menu-open');
        }
    });
}

if (dropDownItems.length !== 0) {
    dropDownItems.forEach((dropDown) => {
        let toggle = dropDown.querySelector(".dropdown-toggle");
        let menu = dropDown.querySelector(".dropdown-menu");

        if (toggle != null && menu != null) {
            dropDownMenus.push({ toggle: toggle, menu: menu });
            toggle.addEventListener("click", (e) => {
                e.preventDefault();
                e.stopPropagation();
                dropDownMenuToggle(menu, toggle);
            });

            let indside = false;
            menu.addEventListener("mouseenter", (e) => {
                if (!mq.matches) indside = true;
            });
            menu.addEventListener("mouseleave", (e) => {
                if (!mq.matches) {
                    indside = false;
                    dropDownMenuHide(menu, toggle);
                }
            });

            toggle.addEventListener("mouseenter", (e) => {
                if (!mq.matches && !indside) {
                    dropDownMenuToggle(menu, toggle);
                }
            });

            toggle.addEventListener("mouseleave", (e) => {
                setTimeout(() => {
                    if (!mq.matches && !indside) {
                        dropDownMenuHide(menu, toggle);
                    }
                }, 1);
            });
        }
    });
}
/*********************MENUS END ****************************/